import transHelpers from '@videotools/js/util/transHelpers';

export default {
	methods: {
		translateSectionLabel(section, isPlayerCompetition = false) {
			const sportType = isPlayerCompetition ? 'player_sport' : 'team_sport';
			return transHelpers.transUcfirst(`tag_group.sections.${sportType}.${section}`);
		},
	},
};
